import React from 'react'
import { Grid, CircularProgress } from '@mui/material'
export default function Loader({ height }) {
    return (
        <Grid container justifyContent='center' alignItems='center' style={{ height }}>
            <CircularProgress style={{ color: '#000' }} disableShrink />
        </Grid>
    )
}